import Controller from '@ember/controller';
import { action } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

const LOGIN_STEPS = {
  EMAIL: 'email',
  CODE: 'code',
} as const;

type LoginStep = (typeof LOGIN_STEPS)[keyof typeof LOGIN_STEPS];

export default class LoginController extends Controller {
  @service declare intl: Services['intl'];

  @tracked currentStep: LoginStep = LOGIN_STEPS.EMAIL;
  @tracked userEmail = '';

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get pageTitle() {
    return this.intl.t('login.title');
  }

  @action
  onEmailVerified(email: string): void {
    this.userEmail = email;
    this.currentStep = LOGIN_STEPS.CODE;
  }
}
